import { useEffect, useState } from 'react'
import { useAppDispatch } from '@hooks/reduxHooks'
import { setInvoiceFilters } from '@state/reducers/invoiceReducer'
import { InvoiceEntity, InvoicePaymentStatus } from '@services/dtos'
import PatientInvoicesTable from './PatientInvoicesTable'

type Props = {
  patientId: number
  onPaymentComplete?: (orderId: number | null) => void
}

export default function PatientInvoicesQuickPay({
  patientId,
  onPaymentComplete,
}: Props) {
  const dispatch = useAppDispatch()
  const [ready, setReady] = useState(false)

  useEffect(() => {
    dispatch(
      setInvoiceFilters({
        entity: InvoiceEntity.PATIENT,
        status: InvoicePaymentStatus.TO_BE_PAID,
        patientId,
      }),
    )
    setReady(true)
  }, [patientId])

  if (!ready) return null
  return (
    <PatientInvoicesTable
      preventFiltersReset
      onPaymentComplete={onPaymentComplete}
    />
  )
}
